export const JWT_INVALID_TOKEN = "JWT_INVALID_TOKEN";
export const JWT_EXPIRED_TOKEN = "JWT_EXPIRED_TOKEN";

export const LDAP_CONNECT_FAIL = "Failed to connect to LDAP server: ";

export const AUTH_MISSING_CREDENTIALS =
  "AUTH_MISSING_CREDENTIALS: provide username and password or token";

export const AUTH_USER_NOT_FOUND =
  "AUTH_USER_NOT_FOUND: Credential invalid or user doesnt exists";

export const AUTH_USER_DATA_ERROR =
  "AUTH_USER_DATA_ERROR: The user returned does not contain the configured usernameAttribute";
